module.exports = __webpack_public_path__ + "img/1558924952.de995965.jpg";